module.exports = __webpack_public_path__ + "img/公共人才库.fb543a5c.png";